import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsForm.vue?vue&type=template&id=44537cef&"
import script from "./OfficialHolidaysPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports